import { applyMiddleware, compose, createStore } from "redux"
import logger from "redux-logger";
import thunk from 'redux-thunk';
import reducer from "./reducers"
import {persistStore} from "redux-persist";

//  export default createStore(reducer, applyMiddleware(thunk, logger));
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; 
export default createStore(reducer, composeEnhancers(applyMiddleware(thunk)));